import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import Icon from "@/components/Icon";
import AdminLayout from "@/components/AdminLayout";

export default function AdminMedia() {
  const [media, setMedia] = useState(null);
  const [q, setQ] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/admin/media", { params: { q: q || undefined } }).then(({ data }) => setMedia(data.media)).catch(() => {});
  useEffect(() => { load(); }, [q]); // eslint-disable-line

  const upload = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", file);
    try { await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Uploaded"); load(); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };
  const del = async (m) => { if (!window.confirm(`Delete ${m.filename}?`)) return; try { await api.delete(`/admin/media/${m.id}`); toast.success("Deleted"); load(); } catch (err) { toast.error(apiError(err.response?.data?.detail)); } };
  const copy = (url) => { navigator.clipboard?.writeText(url); toast.success("URL copied"); };

  return (
    <AdminLayout title="Media Library" subtitle="Upload logos, icons and images for branding and pages"
      actions={<><input ref={fileRef} type="file" data-testid="media-file" onChange={upload} className="hidden" /><button data-testid="media-upload" onClick={() => fileRef.current?.click()} disabled={uploading} className="rounded-xl bg-primary text-primary-foreground px-4 py-2 text-sm font-bold hover:opacity-90 disabled:opacity-60">{uploading ? "Uploading..." : "Upload"}</button></>}>
      <div className="mb-4 max-w-sm relative">
        <Icon name="Search" className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search files" className="w-full rounded-xl border border-input bg-background pl-9 pr-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary/40" />
      </div>
      {!media ? <div className="grid place-items-center py-20"><Icon name="Loader2" className="h-7 w-7 animate-spin text-primary" /></div> : media.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-12 text-center text-muted-foreground text-sm">No media yet. Upload your first asset.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="admin-media">
          {media.map((m) => (
            <div key={m.id} data-testid={`media-${m.id}`} className="rounded-2xl border border-border bg-card overflow-hidden">
              <div className="aspect-video bg-muted grid place-items-center overflow-hidden">
                {(m.content_type || "").startsWith("image") ? <img src={m.url} alt={m.filename} className="h-full w-full object-contain" /> : <Icon name="File" className="h-8 w-8 text-muted-foreground" />}
              </div>
              <div className="p-3">
                <div className="text-sm font-medium truncate" title={m.filename}>{m.filename}</div>
                <div className="text-xs text-muted-foreground">{Math.round((m.size || 0) / 1024)} KB</div>
                <div className="flex gap-1.5 mt-2">
                  <button onClick={() => copy(m.url)} className="flex-1 text-xs rounded-lg border border-border px-2 py-1 hover:bg-accent">Copy URL</button>
                  <button onClick={() => del(m)} className="text-xs rounded-lg border border-red-500/40 text-red-500 px-2 py-1 hover:bg-red-500/10">Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
